import { render, staticRenderFns } from "./DecastLogin.vue?vue&type=template&id=6820430c&scoped=true&"
import script from "./DecastLogin.vue?vue&type=script&lang=js&"
export * from "./DecastLogin.vue?vue&type=script&lang=js&"
import style0 from "./DecastLogin.vue?vue&type=style&index=0&id=6820430c&scoped=true&lang=css&"
import style1 from "./DecastLogin.vue?vue&type=style&index=1&id=6820430c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6820430c",
  null
  
)

export default component.exports